import {Template} from "../../../../components/template/template.jsx";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import React, {useCallback, useMemo, useRef, useState} from "react";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../utils/ag-grid-columns-utils.js";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import {useQuery} from "@tanstack/react-query";
import PassageLabelsService from "../../../../services/web/passage-labels-service.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";
import {useFormNavigation} from "../../../../hooks/use-form-navigation.js";
import {onFilterChanged} from "../../../../utils/ag-grid-filters-utils.js";

const initialFilters = {
    name: ""
}

const pathModel = {
    create: {
        dev: `/passage-labels/form`,
        isBlank: false
    },
    edit: {
        dev: `/passage-labels/form`,
        isBlank: true
    }
}
const PassageLabelsList = () => {
    const [filters, setFilters] = useState(initialFilters)
    const { onRowClicked, openForm } = useFormNavigation(pathModel);
    const columnDefs = useMemo(() => [
        {
            headerName: "Nome",
            field: "name",
            flex: 2,
            filter: "agTextColumnFilter",
            sort: "asc"
        },
        {
            headerName: "Visibilidade",
            field: "visibility",
            flex: 1.5,
            valueGetter: (params) => {
                const type = params.data?.visibility?.type;

                if (type === "ALL") return "Todos";
                if (type === "GROUPS") return "Grupos de operação";
                if (type === "USER") return "Meu agente";

                return type ?? "-";
            },
        },
        {
            headerName: "Data/hora de cadastro",
            field: "dtCreate",
            flex: 1.8,
            valueFormatter: (params) => {
                if (!params.value) return "-";

                return format(
                    parseISO(params.value),
                    "dd/MM/yyyy HH:mm",
                    { locale: ptBR }
                );
            },
        },
        {
            headerName: "Cadastrado por",
            field: "userNameCreate",
            flex: 2,
        },
    ], [])
    const gridApi = useRef(null)

    const {data} = useQuery({
        queryFn: () => PassageLabelsService.list(),
        queryKey: ["list"],
    })

    const search = useCallback(() => {
        if (!gridApi.current) return;

        if (!filters.name || filters.name.trim() === "") {
            gridApi.current.setFilterModel(null);
            return;
        }

        const filterModel = {};

        filterModel['name'] = {
            filterType: "text",
            type: "contains",
            filter: filters.name
        };
        gridApi.current.setFilterModel(filterModel);
        gridApi.current.onFilterChanged();
    }, [filters]);

    const clear = useCallback(() => {
        setFilters(initialFilters)
        const api = gridApi.current;
        if (api) {
            api.setFilterModel(null);
            api.onFilterChanged();
        }
    }, [])

    useGlobalKey("Enter", search);
    useGlobalKey("Escape", clear);

    return(
        <Template>
            <Template.Header>
                <Template.Title>Marcadores de passagem</Template.Title>
                <Button onClick={openForm}><FaPlus/>Adicionar marcador</Button>
            </Template.Header>
            <Template.Body>
                <Card>
                   <Card.Body>
                       <div className="flex gap-4">
                           <div className="flex-1">
                               <InputForm label="Nome" value={filters.name} onInput={({target}) =>
                                   setFilters(prev => ({...prev, name: target.value}))}/>
                           </div>
                           <div className="flex gap-2">
                               <Button target="primary-outline" onClick={clear} title="Limpar">
                                   <FaEraser/>
                               </Button>
                               <Button target="primary" onClick={search} title="Buscar">
                                   <FaSearch/>
                               </Button>
                           </div>
                       </div>
                   </Card.Body>
                </Card>
                <Card className="mt-2">
                    <Card.Body>
                        <div className="h-[calc(100vh-153px)]">
                            <AgGridReact
                                onGridReady={(params) => {
                                    gridApi.current = params.api
                                }}
                                rowData={data}
                                columnDefs={columnDefs}
                                defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
                                paginationPageSize={50}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                onRowClicked={onRowClicked}
                                suppressCellFocus={true}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                onFilterChanged={onFilterChanged}
                                theme={aggridUtils.generalTheme()}
                                overlayNoRowsTemplate={
                                    'Sem dados para exibir.'
                                }
                            />
                        </div>

                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}

export default PassageLabelsList;